import * as S from './styles'

export function InputText({ ...props }) {
  return <S.InputText type='text' {...props} isWithError={props.isWithError} />
}
